import React from 'react'
import PropTypes from 'prop-types'

import { formTypes } from 'utils/constants/formTypes'
import { NJForm } from 'containers/common/formByState/forms/NJForm'
import { MIForm } from 'containers/common/formByState/forms/MIForm'
import { PAForm } from 'containers/common/formByState/forms/PAForm'
import { UTForm } from 'containers/common/formByState/forms/UTForm'
import { CTForm } from 'containers/common/formByState/forms/CTForm'
import { DCForm } from 'containers/common/formByState/forms/DCForm'
import { ORForm } from 'containers/common/formByState/forms/OR/ORForm'
import { AZForm } from 'containers/common/formByState/forms/AZForm'
import { NMForm } from 'containers/common/formByState/forms/NMForm'
import { CAForm } from 'containers/common/formByState/forms/CA/CAForm'

export const FormByState = ({
  type,
  formId,
  formData,
  formMeta,
  handleFieldChange,
  handleUploadScan,
  handleDeleteScan,
  setIsFormBusy,
}) => {
  const formProps = {
    formId,
    formData,
    formMeta,
    handleFieldChange,
    handleUploadScan,
    handleDeleteScan,
    setIsFormBusy,
  }

  switch (type) {
    case formTypes.NJ_EMPLOYMENT_REFERENCE:
      return <NJForm {...formProps} />

    case formTypes.MI_EMPLOYMENT_REFERENCE:
      return <MIForm {...formProps} />

    case formTypes.PA_EMPLOYMENT_REFERENCE:
      return <PAForm {...formProps} />

    case formTypes.UT_EMPLOYMENT_REFERENCE:
      return <UTForm {...formProps} />

    case formTypes.CT_EMPLOYMENT_REFERENCE:
      return <CTForm {...formProps} />

    case formTypes.OR_EMPLOYMENT_REFERENCE:
      return <ORForm {...formProps} />

    case formTypes.CA_EMPLOYMENT_REFERENCE:
      return <CAForm {...formProps} />

    case formTypes.DC_EMPLOYMENT_REFERENCE:
      return <DCForm {...formProps} />

    case formTypes.AZ_EMPLOYMENT_REFERENCE:
      return <AZForm {...formProps} />

    case formTypes.NM_EMPLOYMENT_REFERENCE:
      return <NMForm {...formProps} />

    default:
      return null
  }
}

FormByState.propTypes = {
  type: PropTypes.string.isRequired,
  formData: PropTypes.object.isRequired,
  formMeta: PropTypes.object.isRequired,
  handleFieldChange: PropTypes.func.isRequired,
  handleUploadScan: PropTypes.func.isRequired,
  handleDeleteScan: PropTypes.func.isRequired,
  setIsFormBusy: PropTypes.func.isRequired,
  formId: PropTypes.string.isRequired,
}
